import { Typography } from '@mui/material'
import React, { FC, PropsWithChildren } from 'react'

export const InputLegend: FC<PropsWithChildren<{}>> = ({ children }) => (
  <Typography variant="h5" component="legend" sx={{ paddingTop: '0.75rem', marginBottom: '0.175rem' }}>
    {children}
  </Typography>
)
